import { call, put } from 'redux-saga/effects';
import { getDraftSuccess, getDraftFailure } from '../redux/actions';
import { startRequest as startRequestLoadingContacts } from '../../../../Contacts/redux/contacts/actions';
import { startRequest as startPropertyObjects } from '../../../../App/redux/propertyObjects/actions';
import getData from '../services/getData';

export function* initSaga({ payload }) {
  yield put(startPropertyObjects());
  yield put(startRequestLoadingContacts());
  const { isOk, data, error } = yield call(getData, payload);
  if (isOk && data) {
    yield put(getDraftSuccess(data));
  } else {
    yield put(getDraftFailure(error));
  }
}
